















import Vue from 'vue'
import * as GoogleMaps from 'vue2-google-maps'
import { Map, Polyline as TripLine } from 'vue2-google-maps'
import GoogleConfig from '@/config/google'
import { tracefyOrange } from '@/plugins/vuetify'
// fp-ts
import { flow } from 'fp-ts/lib/function'
import * as O from 'fp-ts/Option'
// Types
import { Report } from '@/components/Reports/types'
import { nightmode } from '@/components/Map/styles'

Vue.use(GoogleMaps, {
  load: {
    key: GoogleConfig.apiKey,
    libraries: GoogleConfig.libraries
  }
})

type Trip = Record<string, string>

export default Vue.extend({
  name: 'MapContainer',
  props: {
    item: Object,
    reports: Array
  },
  components: {
    TripLine,
    Map
  },
  computed: {
    options () {
      if (this.$vuetify.theme.dark) {
        return {
          disableDefaultUI: true,
          styles: nightmode
        }
      } else {
        return {
          disableDefaultUI: true,
          styles: []
        }
      }
    }
  },
  methods: {
    async loadMarkersForTrip (t: Trip): Promise<void> {
      flow(
        O.fromPredicate((t: Trip) => t !== null && t.line !== null),
        O.map((t: Trip) => this.$refs[t.id].$mapPromise.then(() => this.setMarker(t.id, t)))
      )(t)
    },
    setMarker (id: string, trip: Trip) {
      const index = this.reports.findIndex((r: Report) => r.id === id)
      this.axios.get(`trips/${trip.id}`).then((result: any) => {
        const path = [] as any[]
        const { data } = result
        const trip = data.data

        trip.waypoints.forEach((w: any) => {
          path.push({
            lat: w.position.latitude,
            lng: w.position.longitude
          })
        })

        const line = {
          path,
          id: trip.id,
          geodesic: true,
          strokeColor: tracefyOrange,
          strokeOpacity: 1,
          strokeWeight: 5,
          markers: [{
            icon: '/img/markers/start.png',
            position: path[0]
          }, {
            icon: '/img/markers/end.png',
            position: path[path.length - 1]
          }]
        }

        const bounds = new google.maps.LatLngBounds()
        const reports = [...this.reports]

        line.path.forEach((b: google.maps.LatLng) => bounds.extend(b))
        reports[index] = { ...reports[index], line }

        this.$emit('updateWithMarkers', reports)
          this.$refs[id]?.$mapObject.fitBounds(bounds)
      })
    }
  },
  mounted () {
    this.loadMarkersForTrip(this.item)
  }
})
